<template>
	<svg :class="{'inactive': $route.path === '/mymessages'}" width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.7148 0.0976562H2.28516C1.9334 0.0976562 1.60409 0.184137 1.30615 0.32668L12.9492 11.9698L15.5588 9.46182C15.5588 9.46182 15.559 9.46157 15.5591 9.46146C15.5591 9.46136 15.5593 9.46126 15.5593 9.46126L24.6942 0.326883C24.3962 0.184238 24.0667 0.0976562 23.7148 0.0976562Z" fill="#B8CDD7"/>
<path d="M25.7713 1.40417L17.1749 10.0001L25.771 18.5962C25.9135 18.2983 26 17.969 26 17.6172V2.38283C26 2.03127 25.9137 1.70201 25.7713 1.40417Z" fill="#B8CDD7"/>
<path d="M0.229023 1.40381C0.0864805 1.70174 0 2.03106 0 2.38282V17.6172C0 17.9687 0.0863789 18.2981 0.22882 18.5959L8.82522 10L0.229023 1.40381Z" fill="#B8CDD7"/>
<path d="M16.0978 11.0773L13.4878 13.5855C13.339 13.7343 13.1441 13.8087 12.9493 13.8087C12.7544 13.8087 12.5595 13.7343 12.4107 13.5855L9.90234 11.0771L1.30579 19.6731C1.60377 19.8158 1.93329 19.9024 2.28515 19.9024H23.7148C24.0666 19.9024 24.3959 19.8159 24.6939 19.6733L16.0978 11.0773Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
svg {
	cursor: pointer;

}
svg:not(.inactive) {
	path {
		transition: all 0.2s ease;
	}
	&:hover {
		path {
			fill: #8DA0A9 !important;
		}
	}
}
svg.inactive {
	cursor: default !important;
}
</style>